<template lang="html">
  <section class="large-cards">
    <cards>
      <card
        v-for="(link, index) in page_links"
        :key="`card_${index}`"
        v-bind="link"
        :title="link.title"
        :subtitle="link.subtitle"
        :link="link.link"
        :image="link.assets"
        icon="ArrowRight"
        type="large"
      />
    </cards>
  </section>
</template>
<script>
import Heading from '@/components/heading/Heading'
import Cards from '@/sections/cards/Cards'
import Card from '@/components/partials/Card'

export default {
  name: 'SectionDiscover',
  components: {
    Heading,
    Cards,
    Card
  },
  props: {
    page_links: {
      type: Array,
      default: () => []
    },
    buttons: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<docs>
  ```vue
  <section-discover
  title="This is the title"
  :buttons="[{
    text: 'READ ABOUT OUR STORY',
    link: null,
    type: 'button'
  }]"
  :links="[{
    single_word: 'Food',
    title: 'THIS Restaurant',
    image: null, type: 'link',
    link: [
    {
      id: 'd6831efe-136d-4378-a8a2-72276ccdc8e7',
      title: 'About this',
      url: '/discover/about-this',
      permalink: 'http://hotel-api.test/discover/about-this',
      api_url: 'http://hotel-api.test/content-api/collections/discover/entries/d6831efe-136d-4378-a8a2-72276ccdc8e7'
    }]
  },{
    single_word: 'Food 2',
    title: 'THIS Restaurant',
    image: {
      id: 'images::hotel/2611e-restaurant0003.png',
      url: 'http://hotel-api.test/storage/hotel/2611e-restaurant0003.png',
      permalink: 'http://hotel-api.test/storage/hotel/2611e-restaurant0003.png',
      api_url: 'http://hotel-api.test/content-api/assets/images/hotel/2611e-restaurant0003.png',
      width: 375,
      height: 320,
      alt: null
    },
    type: 'link',
    link: [
    {
      id: 'd6831efe-136d-4378-a8a2-72276ccdc8e7',
      title: 'About this',
      url: '/discover/about-this',
      permalink: 'http://hotel-api.test/discover/about-this',
      api_url: 'http://hotel-api.test/content-api/collections/discover/entries/d6831efe-136d-4378-a8a2-72276ccdc8e7'
    }]
  }]"
  />
  ```
</docs>
